<template>
	<div class="box entry-box p-0 mt-1 mb-1">
		<article class="media p-3 article">
			<div class="media-left">
				<AuthorImage v-if="author" :author="author" />
				<AuthorImage v-else :author="undefined" />
			</div>
			<div class="media-content" style="overflow: hidden">
				<div class="mb-0">
					<div class="mt-0 mb-0">
						<div class="
								pt-0
								authorTagContainer
								is-font-medium
							">
							<small>
								{{
									author.attributes?.dependency.attributes.first_name
									+
									" " +
									author.attributes?.dependency.attributes.last_name
								}},
								<time>
									Gültig vom {{
										attendance.attributes?.startDate.toLocaleDateString("de-DE",
											{
												year: "numeric",
												month: "2-digit",
												day: "2-digit",
											}) +
										" bis zum " +
										attendance.attributes?.endDate.toLocaleDateString("de-DE",
											{
												year: "numeric",
												month: "2-digit",
												day: "2-digit",
											})
									}}
								</time>
							</small>
							<ColoredTag v-if="attendance.attributes?.storno" class="mr-1" tag-name="Storno" :tag-color="'#313131'"
								:is-right="true" />					
						</div>
					</div>
					<p class="is-font-extra-large is-font-bold mb-1">
						{{ attendance.attributes?.isAbsence? "Abwesenheit" : "Anwesenheit" }}
					</p>
					<div v-if="!attendance.attributes?.storno">
						<p>
							<small>
								Grund: {{ attendance.attributes?.attendanceAbsence? attendance.attributes?.attendanceAbsence.attributes.name : 
									attendance.attributes?.attendancePresence.attributes.name }}
							</small>
						</p>
						<p>
							<template v-if="attendance.attributes?.hint">
								<small>
									Anmerkung: {{ attendance.attributes?.hint }}
								</small>
							</template>
						</p>
					</div>
					<div v-else>
						<p>
							<small>
								Storno-Grund: {{ attendance.attributes?.stornoReason? attendance.attributes?.stornoReason : "" }}
							</small>
						</p>
					</div>
				</div>
			</div>
		</article>
	</div>
</template>

<script>

import AuthorImage from "@/components/helper/AuthorImage";
import ColoredTag from "@/components/tags/ColoredTag";

export default {
	name: "AttendanceLogEntriesData",
	props: ["attendance"],
	components: {
		AuthorImage,
		ColoredTag,
	},
	data() {
		return {};
	},
	mounted() {	},
	updated() {	},
	watch: { },
	computed: {
		author: function () {
			if (this.attendance?.attributes.author) {
				return this.attendance.attributes.author;
			} else {
				return undefined;
			}
		}
	},
	methods: {},
}
</script>
<style scoped></style>